import { Injectable, EventEmitter } from '@angular/core';
import {
  MyHttpService,
  LoaderService
} from 'potscommonui/src/app/component-library';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PanelistService extends MyHttpService {
  private postheader = new HttpHeaders({ 'Content-Type': 'application/json' });
  private lastPageUrl = '../last-page';

  private signupUrl = '../lsrsdp/signup';

  private changePasswordURL = '../lsrsdp/change-password';

  private formSaveUrl = '../lsrsdp/form';

  private registrationSaveUrl = '../lsrsdp/form-complete';
  private updateProfileUrl = '../lsrsdp/update-profile';
  private formAddressValUrl = '../lsrsdp/validate-address';
  private getHalfbakedInfoUrl = '../lsrsdp/halfbaked-panelist-info';

  private getPanelistInfoUrl = '../lsrsdp/panelist-info';

  private completeRegistrationUrl = '../lsrsdp/complete-registration';

  private getActiveInfoUrl = '../lsrsdp/active-info';

  private meterLinkUrlDirect =
    '../lsrsdp/meter-link-direct';
  private downloadLinkUrl = '../lsrsdp/download-link';

  private forgotpasswordValUrl = '../lsrsdp/validated-forgot-password';

  private interviewerRefreshUrl = '../interviewer';

  private interviewerRetriggerDoubleOptinUrl =
    '../lsrsdp/retrigger-double-optin';
  private deviceIdUrl = '../lsrsdp/get-device-id';
  private unsubscribeURL = '../lsrsdp/unsubscribe';

  panelistLoader = new EventEmitter<boolean>();
  constructor(http: HttpClient, loaderService: LoaderService) {
    super(http, loaderService);
  }
  signup(requestBody) {
    return this.performAjaxCall(this.signupUrl, 'POST', requestBody, true);
    
  }

  retriggerDoubleoptin(requestBody) {
    return this.performAjaxCall(
      this.interviewerRetriggerDoubleOptinUrl,
      'POST',
      requestBody,
      true
    );
  }
  completeRegistration(requestBody) {
    return this.performAjaxCall(
      this.completeRegistrationUrl,
      'POST',
      requestBody,
      true
    );
  }

  getHalfbaked(requestBody) {
    return this.performAjaxCall(
      this.getHalfbakedInfoUrl,
      'POST',
      requestBody,
      true
    );
  }
  getPanelistInfo(requestBody) {
    return this.performAjaxCall(
      this.getPanelistInfoUrl,
      'POST',
      requestBody,
      true
    );
  }
  getActiveInfo(requestBody) {
    return this.performAjaxCall(
      this.getActiveInfoUrl,
      'POST',
      requestBody,
      true
    );
  }

  downloadLink(requestBody) {
    return this.performAjaxCall(
      this.downloadLinkUrl,
      'POST',
      requestBody,
      true
    );
  }
  getMeterLinkDirect(requestBody) {
    return this.performAjaxCall(
      this.meterLinkUrlDirect,
      'POST',
      requestBody,
      true
    );
  }
  getMeterLink(url) {
    this.panelistLoader.emit(true);
    return this.http
      .get(url, {
        // headers: this.postheader,
        responseType: 'blob',
        observe: 'response'
      })
      .pipe(
        map(el => {
          return {
            // filename: (el as any).headers.get('Content-Disposition'),
            data: (el as any).body
          };
        }),
        finalize(() => {
          this.panelistLoader.emit(false);
        }),
        catchError(this.handleErrorLocal)
      );

  }

  saveRegisterform(requestBody) {
    return this.performAjaxCall(this.formSaveUrl, 'POST', requestBody, true);
  }
  saveRegistration(requestBody){
    return this.performAjaxCall(
      this.registrationSaveUrl,
      'POST',
      requestBody,
      true
    );
  }
  updateProfile(requestBody) {
    return this.performAjaxCall(
      this.updateProfileUrl,
      'PUT',
      requestBody,
      true
    );
  }
  private handleErrorLocal(error: HttpErrorResponse | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpErrorResponse) {
      errMsg = `${error.status} - ${error.statusText || ''} @ ${error.url
        }\n${JSON.stringify(error)}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return observableThrowError(error);
  }

  validateAddress(requestBody) {
    return this.performAjaxCall(
      this.formAddressValUrl,
      'POST',
      requestBody,
      true
    );
  }

  changePassword(requestBody) {
    return this.performAjaxCall(
      this.changePasswordURL,
      'POST',
      requestBody,
      true
    );
  }
  forgotPassword(requestBody) {
    return this.performAjaxCall(
      this.forgotpasswordValUrl,
      'POST',
      requestBody,
      true
    );
  }
  getlastPage(requestBody) {
    return this.performAjaxCall(this.lastPageUrl, 'POST', requestBody, true);
  }
  getDeviceId(requestBody) {
    // return this.performAjaxCall(this.deviceIdUrl, 'POST', requestBody, true);
    return of({ "deviceId": 0, "message": "Success" });
  }
  refreshInterviewer(requestBody) {
    return this.performAjaxCall(
      this.interviewerRefreshUrl,
      'POST',
      requestBody,
      true
    );
  }
  unsubscribe(requestBody){
    return this.performAjaxCall(
      this.unsubscribeURL,
      'POST',
      requestBody,
      true
    );
  }

}
